import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import sortedPosts from "../Data/Posts";
import "./PostPage.css";
import ErrorPage from "./error/ErrorPage";
import Header from "../header/Header";
import ShareButtons from "../share/ShareButtons";
import Footer from "../Footer";

const PostPage = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [clickCount, setClickCount] = useState(0);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const count = localStorage.getItem("count");
    if (count) {
      setClickCount(parseInt(count));
    }
  }, []);

  function handleClick() {
    const newCount = clickCount + 1;
    setClickCount(newCount);
    localStorage.setItem("count", newCount);
    console.log(`Number of clicks: ${newCount}`);
  }

  const postUrl = window.location.href;

  useEffect(() => {
    // Check if the post data is already present in the local storage
    const postData = localStorage.getItem(`post_${id}`);
    if (postData) {
      setPost(JSON.parse(postData));
      return;
    }

    // Find the post with the matching id
    const foundPost = sortedPosts.find((post) => post.id === id);
    // Check if a post with the matching id was found
    if (!foundPost) {
      return;
    }

    // Store the post data in the local storage
    localStorage.setItem(`post_${id}`, JSON.stringify(foundPost));

    // Update the state with the found post
    setPost(foundPost);
  }, [id]);

  // Check if the sortedPosts array has at least one element
  if (sortedPosts.length === 0) {
    return <p>No posts available</p>;
  }

  // Check if the id parameter is a valid string
  if (typeof id !== "string" || id.trim().length === 0) {
    return <p>Invalid post ID</p>;
  }

  // Find the post with the matching id
  // const post = sortedPosts.find((post) => post.id === id);

  // Check if a post with the matching id was found
  if (!post) {
    return <ErrorPage />;
  }

  const postTitle = post.post_title;
  const postDescription = post.post_description;
  const postImg = post.post_img;

  return (
    <div>
      {/* <!-- Header --> */}
      <Header />

      {/* <!-- Post Content --> */}
      <section className="post-header">
        <div className="header-content post-container">
          <Link to="/" className="back-home">
            Back To Home
          </Link>
          <h1 className="header-title">{post.post_title}</h1>
          <img
            src={post.post_img}
            alt={post.post_img_alt}
            className="header-img"
          />
        </div>
      </section>

      {/* <!-- Post --> */}
      <section className="post-content post-container">
        <h2 className="sub-heading">{post.content.sub_title1}</h2>
        <p className="post-text">{post.content.content_details_1}</p>
        <p className="post-text">{post.content.content_details_2}</p>
        <h2 className="sub-heading">{post.content.sub_title2}</h2>
        <p className="post-text">{post.content.content_details_3}</p>
        <p className="post-text">{post.content.content_details_4}</p>
        <p className="post-text">{post.content.content_details_5}</p>
        <p className="post-text">{post.content.content_details_6}</p>
        <p className="post-text">{post.content.content_details_7}</p>
        <p className="post-text">{post.content.content_details_8}</p>
        <p className="post-text">{post.content.content_details_9}</p>
        <p className="post-text">{post.content.content_details_10}</p>
        {post.content.link_to_file ? (
          <a
            href={post.content.link_to_file}
            download
            onClick={handleClick}
            className={`download-link animated ${hover ? "bounce" : ""}`}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            Click Here to Download
          </a>
        ) : null}
      </section>

      {/* <!-- Share --> */}
      <div className="share post-container">
        <span className="share-title">Share this article</span>
        <div className="social">
          <ShareButtons
            postUrl={postUrl}
            postImg={postImg}
            postDescription={postDescription}
            postTitle={postTitle}
          />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PostPage;
